import { render, staticRenderFns } from "./gunlukturlistesi.vue?vue&type=template&id=6530dba7&"
import script from "./gunlukturlistesi.vue?vue&type=script&lang=js&"
export * from "./gunlukturlistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports